/** 公開トークンの接頭辞(ADR-0015)。 */
export const PUBLIC_TOKEN_PREFIX = 'pv_';
//# sourceMappingURL=public-api.js.map